import {AppDocumentType} from "../../../types/AppDocumentType";

export const CALENDAR_CHANGE_LOG_COLLECTION = "calendarChangeLog";

export type CalendarChangeLogType =
    "EVENT"
    | "START_DATE"
    | "DAY_TYPE"
    | "DESCRIPTION"
    | "IS_SUPERVISOR"
    | "IS_WAREHOUSE"
    | "IS_MONTAGE"
    | "END_DATE"
    | "REST_TIME"
    | "BONUS"
    | "FACE"
    | "NOTES"
    | "IS_CONFIRMED"
    | "DELETE"
    | "LOCK"
    | "UNLOCK";

export type CalendarChangeLogDocument = AppDocumentType & {
    changeType: CalendarChangeLogType;
    operationId: string;
    calendarItemId: string | null;
    department: string;
    eventId: string;
    eventNumber: string;
    eventName: string;
    employeeId: string | null;
    employeeName: string;
    periodStart: Date | null;
    periodEnd: Date | null;
    previousValue: string;
    newValue: string;
    changedAt: Date;
    changedByEmployeeId: string | null;
    changedByName: string;
};
